import dompurify from "isomorphic-dompurify";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import { Txt, useTranslations } from "@jti/ui";

import { LOYALTY_CHOICE } from "@checkout/hooks/useLoyalty";

import styles from "./SummaryLoyaltyPoints.module.scss";

const { sanitize } = dompurify;

interface SummaryLoyaltyPointsProps {
  hasLoyalty: boolean;
  totalLoyaltyPoints: number;
  // FIXME: should be enum LOYALTY_CHOICE
  loyaltyChoice: number;
}

export const SummaryLoyaltyPoints = (props: SummaryLoyaltyPointsProps) => {
  const { __ } = useTranslations();
  const { totalLoyaltyPoints, loyaltyChoice } = props;
  const checkoutConfiguration = useCheckoutConfiguration();

  if (loyaltyChoice === LOYALTY_CHOICE.COLLECT && totalLoyaltyPoints) {
    return (
      <Txt className={styles.loyaltyPrice} variant={"txt-3"}>
        {__("cart.ploom_club.pointsBlock.collect_message", [totalLoyaltyPoints || ""])}
      </Txt>
    );
  }

  return (
    <div className={styles.loyaltyPriceWrapper}>
      <div
        data-testid={"noPointsMessage"}
        dangerouslySetInnerHTML={{
          __html: sanitize(__("loyalty.checkout.noPointsMessage")),
        }}
        className={styles.loyaltyPrice}
      />
      {checkoutConfiguration?.loyalty?.learnMoreUrl ? (
        <a
          href={checkoutConfiguration.loyalty.learnMoreUrl}
          className={styles.loyaltyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {__("loyalty.checkout.learnMore")}
        </a>
      ) : null}
    </div>
  );
};
